import { MediaFolderId, MediaFolderResponse, MediaId, MediaItemResponse, MediaItemType, MediaRequest, MediaResponse } from '@business/entities/media';
import { Endpoint } from '../endpoint';
import { CommonService } from '@business/services';
import { R } from '@core/utils/r';

export function getItems(parentId?: MediaFolderId) {
  return Endpoint.get<MediaItemResponse>(`@gc/media`, { params: { parentId } });
}

export function fetchFolders() {
  return Endpoint.get<MediaFolderResponse[]>(`@gc/media/folders`);
}

export function fetchMedia() {
  return Endpoint.get<MediaResponse[]>(`@gc/media/media`);
}

export function fetchMediaByHash(hash: string) {
  return Endpoint.get<MediaResponse>(`@gc/media/hash/${hash}`);
}

export function moveItem(itemId: string, type: MediaItemType, folderId: MediaFolderId, oldFolderId?: MediaFolderId) {
  return Endpoint.post<void>(`@gc/media/move`, { data: { itemId, type, folderId, oldFolderId } });
}

export function createFolder(name: string, parentId?: MediaFolderId, files?: MediaId[]) {
  return Endpoint.post<MediaFolderResponse>(`@gc/media/folder`, { data: { name, parentId, files } });
}

export function updateFolder(id: MediaFolderId, name: string, files?: MediaId[]) {
  return Endpoint.patch<MediaFolderResponse>(`@gc/media/folder/${id}`, { data: { name, files } });
}

export function deleteFolder(id: MediaFolderId) {
  return Endpoint.delete<void>(`@gc/media/folder/${id}`);
}

export function deleteMedia(id: MediaId, folderId?: MediaFolderId) {
  return Endpoint.delete<void>(`@gc/media/${id}`, { data: { folderId } });
}

export function createMedia(data: MediaRequest, parentId?: MediaFolderId) {
  const formData = CommonService.toFormData(data);
  formData.append('parentId', parentId ? parentId : '0');
  //   return mediaRequest(`@gc/media`, data, parentId);
  return Endpoint.post<MediaResponse[]>(`@gc/media`, { formData, hasFiles: true });
}

export function updateMedia(id: MediaId, data: MediaRequest) {
  return mediaRequest(`@gc/media/${id}`, data, undefined, true);
}

function mediaRequest(url: string, data: MediaRequest, parentId?: MediaFolderId, isPatch = false) {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('type', data.type);
  formData.append('url', data.url);
  //   const singleFile = (!!data.files?.length && data.files[0]) || [];
  //   formData.append('files', singleFile);
  const files = data.files || [];
  files.forEach(file => formData.append('files', file));

  formData.append('parentId', parentId ? parentId : '0');

  if (isPatch) {
    formData.append('_method', 'PATCH');
  }
  return Endpoint.post<MediaResponse>(url, {
    formData: formData,
    hasFiles: true,
  });
}
